import { Button as MuiButton, styled } from '@material-ui/core';

export const Button = styled(MuiButton)(({ theme }) => ({
  fontSize: theme.spacing(2),
}));
